import React from 'react'
import { NO_ACCESS_MSG } from '../lib/permissions'

export default function NoAccess({ message = NO_ACCESS_MSG, detail, compact }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', padding: compact ? '24px 16px' : '80px 20px', flex: compact ? undefined : 1,
      fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    }}>
      <div style={{ fontSize: compact ? 28 : 44, marginBottom: 10 }}>🔒</div>
      <div style={{ fontSize: compact ? 14 : 16, fontWeight: 700, color: '#475569' }}>{message}</div>
      {detail && <div style={{ fontSize: 13, color: '#94a3b8', marginTop: 6, maxWidth: 420 }}>{detail}</div>}
    </div>
  )
}
